module.exports = __webpack_public_path__ + "static/media/coffee_cup.61fb9ae4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/coffee_cup.svg
// module id = 237
// module chunks = 0